import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  websiteType: "",
  color: "",
};

const onLoadDataSlice = createSlice({
  name: "onLoadData",
  initialState,
  reducers: {
    setWebsiteType: (state, actions) => {
      state.websiteType = actions.payload;
    },
    setColor: (state, actions) => {
      state.color = actions.payload;
    },
  },
});

export const onLoadDataReducer = onLoadDataSlice.reducer;

export const { setWebsiteType, setColor } = onLoadDataSlice.actions;
